import { CIcon } from '~/icons/types'

export const ciSimpleScooter: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M17.832 14.942 16.83 6.06l1.521-.47a.5.5 0 0 0-.296-.956l-3.559 1.1a.5.5 0 0 0 .148.978.488.488 0 0 0 .148-.022l1.066-.33.662 5.87-.005.004-3.446 4.159H6.228a2.01 2.01 0 1 0 0 1h7.076a.502.502 0 0 0 .385-.18l2.986-3.604.153 1.358a2.002 2.002 0 1 0 1.004-.025ZM4.287 17.904a1.01 1.01 0 1 1 1.011-1.011 1.011 1.011 0 0 1-1.01 1.01Zm13.083 0a1.01 1.01 0 1 1 1.01-1.011 1.012 1.012 0 0 1-1.01 1.01Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'simple-scooter',
  type: 'thin'
}
